<template>
    <div :class="getCSSClass('music-contributor-manager-button-container')">
        <button :class="getCSSClass('music-contributor-manager-button')"
                v-html="buttonIcon"
                v-on:click="openPopup"></button>
        <popup :visible="showPopup"
               v-on:close="showPopup = false">
            <music-contributor-manager v-if="contributorData"
                                       :key="mountingKey"
                                       :errors="validationErrors"
                                       v-model="contributorData"></music-contributor-manager>
            <div :class="getCSSClass('music-contributor-manager-buttons-row')">
                <button :class="getCSSClass('music-contributor-manager-save-button')"
                     v-on:click="saveData"
                     v-html="icon('save')+translate('Mentés')"
                ></button>
                <button :class="getCSSClass('music-contributor-manager-cancel-button')"
                     v-on:click="showPopup = false"
                     v-html="icon('cancel')+translate('Mégse')"
                ></button>
            </div>
        </popup>
    </div>
</template>

<script>
    export default {
        inject: ['loadingIndicator', 'getCSSClass', 'translate', 'icon'],
        props: {
            operationsUrl: {type: String},
            buttonIcon: {type: String},
            subject: {},
            parent: {type: Object, default: () => {return {}}}
        },
        data: function () {
            return {
                showPopup: false,
                contributorData: false,
                mountingKey: 0,
                validationErrors: {},
            }
        },
        mounted() {
        },
        methods: {
            saveData: function() {
                this.validationErrors = {};
                window.axios.post(this.operationsUrl, {parent: this.parentId, data: this.contributorData, action: 'saveData', subject: this.subjectId})
                    .then((response) => {
                        this.showPopup = false;
                        this.$emit('notify', response.data.message);
                    }).catch((error) => {
                        if (error.response.status == 422) {
                            this.validationErrors = error.response.data.errors
                            return;
                        }
                })
            },
            openPopup: function() {
                window.axios.get(this.operationsUrl, {params: {subject: this.subjectId, action: 'fetchContributors'}})
                    .then((response) => {
                        this.contributorData = response.data;
                        this.showPopup = true;
                    })
            }
        },
        computed: {
            subjectId: function() {
                return this.subject['id'] ? this.subject.id : -1;
            },
            parentId: function() {
                return this.parent['id'] ? this.parent.id : -1;
            }
        },
        watch: {
            showPopup: function() {
                this.mountingKey++;
            }
        }

    }
</script>
